"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
/* intersperse: Return an array with the separator interspersed between
 * each element of the input array.
 *
 * > _([1,2,3]).intersperse(0)
 * [1,0,2,0,3]
 */
function intersperse(arr, sep) {
    if (arr.length === 0) {
        return [];
    }

    return arr.slice(1).reduce(function (xs, x, i) {
        return xs.concat([sep, x]);
    }, [arr[0]]);
}

module.exports = intersperse;
exports.default = intersperse;


//////////////////
// WEBPACK FOOTER
// ./~/linksoft/utils/intersperse.js
// module id = 422
// module chunks = 0